import bowser from 'bowser'
import get from 'lodash/get'

import EventBus, { GlobalEvents } from '@shared/event-bus'

const propertyEventPairs = [
  ['hidden', 'visibilitychange'], // Opera 12.10 and Firefox 18 and later support
  ['msHidden', 'msvisibilitychange'],
  ['webkitHidden', 'webkitvisibilitychange'],
]

class DeviceInfo {
  public parser: bowser.Parser.Parser
  public changeEvent: string
  public hiddenProperty: string

  private _isDocumentVisible = true

  constructor() {
    this.parser = bowser.getParser(window.navigator.userAgent)

    const propertyEventPair = propertyEventPairs.find(
      ([prop]) => prop in document
    )
    // It's weird if this condition resolves to true
    if (!propertyEventPair || propertyEventPair.length < 2) {
      throw Error('Visibility events emitter is not set properly!')
    }
    ;[this.hiddenProperty, this.changeEvent] = propertyEventPair

    if (this.isBrowser('Safari')) {
      this.changeEvent = 'pagehide'
    }

    document.addEventListener(this.changeEvent, this.listener)
  }

  public isBrowser(browser: string) {
    return this.parser.getBrowserName() === browser
  }

  public get isMobile() {
    return ['mobile', 'tablet'].includes(this.parser.getPlatformType())
  }

  public get isDocumentVisible() {
    return this._isDocumentVisible
  }

  private listener() {
    const currentDocumentVisibility = !get(document, this.hiddenProperty)
    if (this._isDocumentVisible !== currentDocumentVisibility) {
      this._isDocumentVisible = currentDocumentVisibility

      EventBus.emit(
        GlobalEvents.DocumentVisibilityChanged,
        this._isDocumentVisible
      )
    }
  }
}

const deviceInfoInstance = new DeviceInfo()

export default deviceInfoInstance
